import type { ReactNode } from 'react';
import * as styles from './List.module.scss';

export interface IListProps {
    children: ReactNode;
    listStyle?: 'none' | 'disc' | 'circle';
    textAlign?: 'left' | 'center' | 'right';
    theme?: 'white' | 'dark';
}

export function List(props: IListProps) {
    let className = styles.list;
    props.listStyle = props.listStyle ?? 'none';

    if (props.listStyle) {
        className += ' ' + styles[props.listStyle];
    }

    if (props.listStyle === 'none') {
        className += ` ${styles.noPadding}`;
    }

    if (props.theme) {
        className += props.theme === 'white' ? ` ${styles.white}` : ` ${styles.dark}`;
    }

    if (props.textAlign) {
        className += ' ' + styles[props.textAlign];
    }

    return <ul className={className}>{props.children}</ul>;
}
